<template>
  <div class="">
    <div class="top-section w-full h-full mb-4">
      <div class="flex justify-between px-4 py-4">
        <div class="sm:flex sm:justify-between w-full items-start md:block left text-center sm:text-left">
          <h5 class="text-2xl md:text-4xl font-bold mb-5">TNY Leaderboard</h5>
        </div>
        <div class="hidden md:block right">
          <img src="https://res.cloudinary.com/lms-edc/image/upload/v1594517172/Assets/chovh7jpbkgd4ixmc2fn.png" alt="">
        </div>
      </div>
    </div>

    <div
        class=" flex flex-col z-10 shadow bg-white mb-12 w-full"
        style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">Leaderboards</div>
      </div>
      <div
          class="relative mx-12 border border-gray-300 focus:shadow-md focus:border-none flex-col rounded-full flex mb-6"
      >
        <input
            class="w-full leading-tight h-10 border-none px-4 bg-gray-200 focus:bg-white focus:outline-none rounded-full pl-10"
            placeholder="Search by Name, Email, or Phone number"
            type="text"
            v-model="search"
            v-on:keydown.enter="handleSearch"
        />
        <div
            class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <svg
              class="fill-current pointer-events-none text-gray-600 w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
          >
            <path
                d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
            ></path>
          </svg>
        </div>


      </div>
    </div>

    <div class=" flex p-5 ">
      <div class="flex items-center">
        <i class="text-gray-500 fas fa-search"></i>
        <span class="font-semibold  ml-1">search By Start Date: </span>
        <div class="relative">
          <datepicker @selected="handleSearch"  v-model="date.start_date" input-class="py-2 px-4 w-full border border-gray focus:outline-none ml-3"/>
        </div>
      </div>
      <div class="sort ml-12 flex items-center">
        <i class="text-gray-500 fas fa-sort-amount-up"></i>
        <span class="font-semibold  ml-2">By end date: </span>
        <div class="relative">
          <datepicker @selected="handleSearch"  v-model="date.end_date" input-class="py-2 px-4 w-full border border-gray focus:outline-none ml-3"/>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-center py-3 bg-white">
      <p @click="showCourse" class="py-2 rounded-sm focus:outline-none mr-10 cursor-pointer" :class="{'border-b-2 border-blue-500': course}">
        Course completed
      </p>
      <p @click="showGrowthPlan" class="py-2 rounded-sm focus:outline-none cursor-pointer" :class="{'border-b-2 border-blue-500': growth_plan}">
        Growth plan
      </p>
    </div>
    <div class="px-8 bg-white" v-show="course">
      <table class="table-auto w-full">
        <thead class="border-b text-left">
          <tr>
            <th class="px-4 py-5">S/N</th>
            <th class="px-4 py-5">First name</th>
            <th class="py-5 px-4">Last name</th>
            <th class="py-5 px-4">Email</th>
            <th class="py-5 px-4">Gender</th>
            <th class="py-5 px-4">Location</th>
            <th class="py-5 px-4">Date Completed</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(course,index) in completed_courses" :key="course.id">
          <td class="px-4 border-b py-5">{{ index+1 }}</td>
          <td class="px-4 border-b py-5">{{ course.first_name }}</td>
          <td class="px-4 border-b py-5">{{ course.last_name }}</td>
          <td class="px-4 border-b py-5">{{ course.email}}</td>
          <td class="px-4 border-b py-5">{{ course.gender }}</td>
          <td class="px-4 border-b py-5">{{ course.location }}</td>
          <td class="px-4 border-b py-5">{{ convertDate(course.updated_at) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="px-8 bg-white" v-show="growth_plan">
      <div class="mb-5">
        <table class="table-auto w-full">
          <thead class="">
          <tr>
            <th class="px-4 py-1">S/N</th>
            <th class="px-4 py-1">First name</th>
            <th class="py-2">Last name</th>
            <th class="py-2">Gender</th>
            <th class="py-2">Phone Number</th>
            <th class="py-2">Location</th>
            <th class="py-2">Date Completed</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(plan,index) in growth_plans.data"  :key="plan.id">
            <td class="px-4 border-b py-5">{{ index+1 }}</td>
            <td class="px-4 border-b py-5">{{ plan.first_name }}</td>
            <td class="px-4 border-b py-5">{{ plan.last_name }}</td>
            <td class="px-4 border-b py-5">{{ plan.gender }}</td>
            <td class="px-4 border-b py-5">{{ plan.phone_number }}</td>
            <td class="px-4 border-b py-5">{{ plan.location }}</td>
            <td class="px-4 border-b py-5">{{ convertDate(plan.updated_at)  }}</td>
          </tr>
          </tbody>
        </table>
      </div>


    </div>

    <!-- Pagination -->
    <div class="px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 mt-6">
      <div class="flex-1 flex justify-between">
        <a href="#" v-if="course" :disabled="!prev_page" @click.prevent="courseCompletedLearners(current_page-1)" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
          Previous
        </a>
        <a href="#" v-if="growth_plan" :disabled="!prev_page" @click.prevent="growthPlanLearners(current_page-1)" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
          Previous
        </a>
        <a v-if="course" href="#" :disabled="!next_page" @click.prevent="courseCompletedLearners(current_page+1)" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
          Next
        </a>
        <a v-if="growth_plan" href="#" :disabled="!next_page" @click.prevent="growthPlanLearners(current_page+1)" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
          Next
        </a>
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Showing
              <span class="font-medium">{{ from }}</span>
              to
              <span class="font-medium">{{ to }}</span>
              of
              <span class="font-medium">{{ total }}</span>
              results
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { mapActions,mapMutations } from "vuex";
import moment from 'moment';
import LmsButton from "../../../components/general/button";

export default {
name: "tenant-leaderboard",
  data(){
    return {
      weekly:'',
      course:true,
      growth_plan:false,
      growth_plans:{},
      completed_courses:{
      },
      date:{
        start_date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        end_date: moment().add(7,'days').format("YYYY-MM-DD HH:mm")
      },
      search:'',
      to:1,
      from:1,
      total:0,
      prev_page:0,
      next_page:0,
      current_page:''
    };
  },
  components:{
      LmsButton,
    Datepicker
  },

  methods:{
    ...mapActions(["fetchCourseCompletionQualifier","fetchGrowthPlanQualifier"]),
    ...mapMutations(["updateLoader"]),
    async showCourse(){
        await  this.courseCompletedLearners()
      this.course = true;
      this.growth_plan = false
    },
    convertDate(date){
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
    async handleSearch(){
        if (this.course){
            await this.courseCompletedLearners()
        }
        else if(this.growth_plan) {
            await this.growthPlanLearners()

        }
    },

    async showGrowthPlan(){
      await this.growthPlanLearners()
        this.course = false;
        this.growth_plan = true;
    },
    async growthPlanLearners(page=1){
      this.updateLoader(true);
      try{
        const res = await this.fetchGrowthPlanQualifier({page:page, search:this.search, start_time:  moment(this.date.start_date).format("YYYY-MM-DD HH:mm"), end_time:  moment(this.date.end_date).format("YYYY-MM-DD HH:mm")});
        this.growth_plans = res.data.growth_plan_completion
        this.makePagination(res.data.growth_plan_completion);
        // console.log(res.data);
        this.updateLoader(false);
      }catch (e) {
          console.log(e)
        this.updateLoader(false);
      }
    },
    async courseCompletedLearners(page=1){
      this.updateLoader(true);
      try {
        const res = await this.fetchCourseCompletionQualifier({page:page, search:this.search, start_time:  moment(this.date.start_date).format("YYYY-MM-DD HH:mm"), end_time:  moment(this.date.end_date).format("YYYY-MM-DD HH:mm")});
        this.makePagination(res.data.course_completion);
        this.completed_courses = res.data.course_completion.data;
        // this.completed_courses = res.data.course_completion.data.filter(course => {course.first_name.toLowerCase().match(this.search.toLowerCase()) || course.last_name.toLowerCase().match(this.search.toLowerCase() || course.gender.toLowerCase().match(this.search.toLowerCase() || course.location.toLowerCase().match(this.search.toLowerCase())))})
        this.updateLoader(false);

      } catch (e) {
        this.updateLoader(false);
      }
    },
    makePagination(data) {
      this.current_page = data.current_page;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.prev_page = data.prev_page_url;
      this.next_page = data.next_page_url;
    },
  },
  async mounted() {
    await this.courseCompletedLearners()
      await this.growthPlanLearners
  }
}
</script>

<style scoped>

</style>

<style lang="scss">
.rewards {
  .top-section {
    background: linear-gradient(61deg,  color(lms-tenant), #fff 100%);
    h5 {
      color: #fff !important;
    }
    button {
      color: color(lms-tenant) !important;
    }
  }
  .home, .details {
    background-color: #fff
  }
  .create {
    background-color: #fff;
    .import {
      color: color(lms-tenant);
    }
  }
}

.page-heading {
  color: color(lms-tenant);
}
</style>